import React, { forwardRef } from "react";

const Button = forwardRef(({ className = "", ...props }, ref) => (
  <button ref={ref} className={`inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none bg-orange-500 text-white hover:bg-orange-600 ${className}`} {...props} />
));

export default Button; 